import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

// Top-of-page scroll progress bar.
export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.2 });
  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-[3px] nm-gold-bg z-[150] origin-left"
      style={{ scaleX }}
      aria-hidden
    />
  );
};

// Infinite scrolling keyword ticker.
export const Marquee = ({ items }) => (
  <div className="relative overflow-hidden border-y border-white/5 bg-[#060A17] py-5" aria-hidden>
    <div className="flex marquee-track whitespace-nowrap">
      {[...items, ...items].map((t, i) => (
        <span key={i} className="flex items-center font-head text-base sm:text-lg font-bold text-white/60 mx-6">
          {t} <span className="nm-gold-text ml-6">◆</span>
        </span>
      ))}
    </div>
  </div>
);

// Diagonal gold light streaks (hero ambiance).
export const LightStreaks = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
    {[...Array(4)].map((_, i) => (
      <span
        key={i}
        className="streak"
        style={{ top: `${16 + i * 22}%`, animationDelay: `${i * 1.6}s`, animationDuration: `${6 + i}s` }}
      />
    ))}
  </div>
);

// Soft animated color blobs for depth.
export const Aurora = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
    <div className="aurora-blob w-[420px] h-[420px] bg-[#2563EB] -top-24 left-[8%]" />
    <div className="aurora-blob w-[320px] h-[320px] bg-[#D4AF37] -bottom-20 right-[10%]" style={{ animationDelay: "5s" }} />
  </div>
);
